import React, { useEffect, useMemo, useState } from "react";
import { CalendarCheck } from "lucide-react";
import { api, fmtDateTime } from "../lib/api";
import { Screen, PageHeader, Empty } from "../components/ui-kit";

const FILTERS = [
  { key: "today", label: "Today" },
  { key: "week", label: "This Week" },
  { key: "month", label: "This Month" },
  { key: "all", label: "All" },
];

export default function Attendance() {
  const [items, setItems] = useState([]);
  const [filter, setFilter] = useState("all");

  useEffect(() => {
    api.get("/attendance").then((r) => setItems(r.data)).catch(() => {});
  }, []);

  const filtered = useMemo(() => {
    const now = new Date();
    return items.filter((it) => {
      const d = new Date(it.created_at);
      if (filter === "today") return d.toDateString() === now.toDateString();
      if (filter === "week") return (now - d) < 7 * 864e5;
      if (filter === "month") return d.getMonth() === now.getMonth() && d.getFullYear() === now.getFullYear();
      return true;
    });
  }, [items, filter]);

  return (
    <Screen>
      <PageHeader overline="History" title="Attendance" back />
      <div className="flex gap-2 mb-6 overflow-x-auto no-scrollbar">
        {FILTERS.map((f) => (
          <button key={f.key} onClick={() => setFilter(f.key)} data-testid={`attendance-filter-${f.key}`}
            className={`whitespace-nowrap px-4 py-2 rounded-full text-sm border transition-colors ${filter === f.key ? "bg-[#D4AF37] text-black border-[#D4AF37]" : "bg-white/5 text-[#A19DB0] border-white/10"}`}>
            {f.label}
          </button>
        ))}
      </div>
      {filtered.length === 0 ? (
        <Empty icon={CalendarCheck} text="No attendance records for this period." />
      ) : (
        <div className="space-y-3">
          {filtered.map((it) => (
            <div key={it.id} data-testid="attendance-item" className="flex items-center gap-4 rounded-2xl bg-white/5 border border-white/10 p-4">
              <div className="w-10 h-10 rounded-full bg-[#9D4EDD]/20 flex items-center justify-center"><CalendarCheck size={18} className="text-[#9D4EDD]" /></div>
              <div className="flex-1 min-w-0">
                <p className="font-medium truncate">{it.title}</p>
                <p className="text-[#A19DB0] text-xs">{fmtDateTime(it.created_at)} · {it.ref_type}</p>
              </div>
              {it.credits_used > 0 && <span className="text-sm text-[#A19DB0]">-{it.credits_used} credit</span>}
            </div>
          ))}
        </div>
      )}
    </Screen>
  );
}
